import { render, staticRenderFns } from "./TaxonomyBreakdown.vue?vue&type=template&id=36783c44&scoped=true"
import script from "./TaxonomyBreakdown.vue?vue&type=script&lang=js"
export * from "./TaxonomyBreakdown.vue?vue&type=script&lang=js"
import style0 from "./TaxonomyBreakdown.vue?vue&type=style&index=0&id=36783c44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36783c44",
  null
  
)

export default component.exports